import React from 'react';
import { useTranslation } from 'react-i18next';
import { PatientListDto } from '../../types/patient.types';
import { PatientCard } from './PatientCard';
import { LoadingSpinner } from '../common/LoadingSpinner';
import { ErrorMessage } from '../common/ErrorMessage';

interface PatientListProps {
  patients?: PatientListDto[];
  isLoading: boolean;
  error: Error | null;
  onRetry?: () => void;
}

export const PatientList: React.FC<PatientListProps> = ({
  patients,
  isLoading,
  error,
  onRetry,
}) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (error) {
    return <ErrorMessage message={error.message} onRetry={onRetry} />;
  }

  if (!patients || patients.length === 0) {
    return (
      <div className="text-center py-5">
        <p className="text-muted mb-0">{t('common.noData')}</p>
      </div>
    );
  }

  return (
    <div className="row g-4">
      {patients.map((patient) => (
        <div key={patient.id} className="col-12 col-md-6 col-lg-4 col-xl-3">
          <PatientCard patient={patient} />
        </div>
      ))}
    </div>
  );
};
